import ApiService, { ApiArguments } from '@/api/api_service';
import { CallFeedbackApi, CallFeedbackApiGetCallFeedbacksRequest, GetCallFeedbacks200Response } from '@/api/openapi';

export class CallFeedbackApiService extends ApiService {
  api = new CallFeedbackApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getCallFeedbacks(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<CallFeedbackApiGetCallFeedbacksRequest>,
  ) {
    return this.checkResponse<GetCallFeedbacks200Response>(
      this.api.getCallFeedbacks(request, options),
      errorHandlers,
    );
  }
};
